import React from 'react';

const Environment = ({className, style, settings}) => (
  <div className={className} style={{...style,bottom:settings.bottom,right:settings.right}}>
    <svg width="36px" height="36px" viewBox="0 0 36 36" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink"><defs><circle id="a" cx={18} cy={18} r={18} /></defs><g transform="rotate(30) translate(8, -10)" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd"><use fill="#A7D4EE" xlinkHref="#a" /><g mask="url(#mask-2)" stroke="#333" strokeLinecap="round" strokeLinejoin="round"><g transform="translate(8.709677, 4.645161)"><path d="M17.906 15.544c0 4.936-3.994 8.938-8.92 8.938-4.927 0-8.921-4.002-8.921-8.938 0-4.252 6.62-12.908 8.454-15.224a.592.592 0 0 1 .933 0c1.834 2.316 8.454 10.972 8.454 15.224zM8.93.054V27.65m8.877-12.574L8.93 21.052m7.11-9.989l-7.055 4.749m4.926-8.716l-4.627 3.115m-9.23 4.866l8.876 5.975m-7.11-9.989l7.055 4.749M3.949 7.096l4.627 3.115" strokeWidth="1.6" /></g></g></g></svg>
  </div>
);

Environment.defaultProps = {
  settings: {
    bottom:0,
    right:0,
  },
  style: {
    position:"absolute",
    zIndex:"500",
  },
};

export default Environment;
